module.exports = __webpack_public_path__ + "img/cert17semanacientifica.8db54afd.png";